import React from 'react'
import PropTypes from 'prop-types'
import { IconPDLSparkle } from '@edulastic/icons'
import {
  StyledAIAssistanceContainer,
  StyledDisclaimerLink,
  StyledDisclaimerText,
  StyledHeaderSection,
  StyledMetadataTitle,
  StyledScrollableContent,
  StyledWrapper,
} from './styled'
import QuestionMetadataSection from './QuestionMetadataSection'

const AIAssistance = ({ onSaveSuggestedMetadata }) => {
  return (
    <StyledWrapper data-cy="pearAssistPanel">
      <StyledAIAssistanceContainer>
        <StyledHeaderSection>
          <IconPDLSparkle width="24px" height="24px" css="flex-shrink: 0;" />
          <StyledMetadataTitle data-cy="pearAssistTitle">
            Use Pear Assist to auto fill standards, DoK and difficulty
          </StyledMetadataTitle>
        </StyledHeaderSection>
        <StyledScrollableContent>
          <QuestionMetadataSection
            onSaveSuggestedMetadata={onSaveSuggestedMetadata}
          />
        </StyledScrollableContent>
        <StyledDisclaimerText>
          Pear Assist uses AI and can make mistakes.{' '}
          <StyledDisclaimerLink
            href="https://www.peardeck.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more
          </StyledDisclaimerLink>
        </StyledDisclaimerText>
      </StyledAIAssistanceContainer>
    </StyledWrapper>
  )
}

AIAssistance.propTypes = {
  onSaveSuggestedMetadata: PropTypes.func,
}

AIAssistance.defaultProps = {
  onSaveSuggestedMetadata: () => {},
}

export default AIAssistance
